//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Toast} from 'vant';
import Header from '../header/header.vue'
import quoLoginModule from "@/pages/product/quoLoginModule"
import companyBindeForm from "@/pages/modules/companyBindeForm"
import createAndBindCompanyForm from "@/pages/modules/createAndBindCompanyForm"
import { commonTool } from '@/util/tool'
import userBindConfirm from "@/pages/modules/userBindConfirm"
export default {
  components:{
    Header,
    quoLoginModule,
    companyBindeForm,
    createAndBindCompanyForm,
    userBindConfirm
  },
  name: 'Home',
  data () {
    return{
      showNav:false,
      userInfo: this.$store.getters.getUserInfo,
      sysApplications: [],
      screenWeight: 0,
      screenHeight: 0,
      curIndex: -1,
      nowTop: 0,
      pageNum: 0,
      main: Object,
      obj: Object,
      checkedApp: null
    }
  },
  mounted () {
    this.fnQueryAllSysApplications()
  },
  methods:{
    handleBtnShowMoreClicked (app) {
      // 进入APP详情
      localStorage.setItem("currentAppInfo", JSON.stringify(app));
      this.$router.push({ path: '/appDetail'});
    },
    fnQueryAllSysApplications () {
      var param = {}
      this.$store.dispatch('sysApp/queryAllSysApplicationInfo', JSON.stringify(param))
        .then(res => {
          console.log('fnQueryAllSysApplications res ==>', res)
          if (res.data && res.data.retCode == 1) {
            res.data.objs.forEach(app => {
              let appNameSplit = app.appName.split('·');
              app.shortName = appNameSplit[0]
              app.shortNameL = appNameSplit[1]
            })
            this.sysApplications = [...res.data.objs]
            this.$nextTick(() => {
              this.fnInitScroll()
            })
          }
        }).catch(err => {
          console.log('fnQueryAllSysApplications err ==>', err)
        })
    },
    fnInitScroll () {
      this.screenWeight = document.documentElement.clientWidth;
      this.screenHeight = document.documentElement.clientHeight;
      this.main = document.getElementById("main");
      this.obj = document.getElementsByTagName("div");
      for (let i = 0; i < this.obj.length; i++) {
        if (this.obj[i].className == 'page') {
          this.obj[i].style.height = this.screenHeight + "px";
        }
      }
      this.pageNum = document.querySelectorAll(".page").length;
      if ((navigator.userAgent.toLowerCase().indexOf("firefox") != -1)) {
        document.addEventListener("DOMMouseScroll", this.scrollFun, false);
      } else if (document.addEventListener) {
        document.addEventListener("mousewheel", this.scrollFun, false);
      } else if (document.attachEvent) {
        document.attachEvent("onmousewheel", this.scrollFun);
      } else {
        document.onmousewheel = this.scrollFun;
      }
    },
    handleBtnUseFreeClicked (app) {
      if (app.id == 'APP_XMPC') {
        if (this.userInfo && this.userInfo.id) {
          this.fnCheckUserBindFactory(app, () => {
            this.$refs.companyBindeForm.showForm(app)
          })
        } else {
          this.checkedApp = app
          this.$refs.quoLoginModule.showLogin()
        }
      } else {
        Toast('暂未开通')
      }
    },
    fnCheckUserBindFactory (app, callBack) {
      var user = {
        userPhone: this.userInfo.userPhone
      }
      var param = {
        in: JSON.stringify(user),
        appId: app.id
      }
      this.$store.dispatch('company/checkUserBindFactory', param)
        .then(res => {
          console.log('fnCheckUserBindFactory res ===>', res)
          if (res.data && res.data.retCode == 1) {
            var user = JSON.parse(res.data.obj)
            if (user && user.userRoleRels && user.userRoleRels.length > 0) {
              this.$refs.userBindConfirm.showConfirm(
                () => {
                  this.$router.push({path: '/quickEnterIn', query: {'appId': app.id}})
                },
                () => {
                  callBack()
                }
              )
            } else {
              callBack()
            }
          } else {
            callBack()
          }
        }).catch(err => {
          console.log('fnCheckUserBindFactory err===>', err)
          Toast(err)
        })
    },
    handleLognSucccess (userInfo) {
      this.userInfo = userInfo
      this.$refs.Header.fnSetUserInfo(this.userInfo)
      this.handleBtnUseFreeClicked(this.checkedApp)
    },
    createAndBindCompanyInfo (appInfo) {
      this.$refs.createAndBindCompanyForm.showForm(appInfo)
    },
    //跳转到平台首页
    fnGoToHomePage(e){
       this.fnStopBub(e);
       this.$router.push({path: '/home'});
    },
    toPage (page) {
      this.curIndex = page
    },
    scroll (event) {
      // this.curIndex = -2
      let y = event.target.scrollTop
      if(y <= 100){
        this.showNav = false
        this.curIndex = -1
        return
      }
      if(y > 500){
          this.showNav = true
      }
      if( y <= this.screenHeight * 2  && y >= this.screenHeight * 2 - this.screenHeight){
        this.curIndex = 0
        return
      }
      if(y  <= this.screenHeight * 3 && y >= this.screenHeight * 3 - this.screenHeight){
        this.curIndex = 1
        return
      }
      if(y  <= this.screenHeight * 4 && y >= this.screenHeight * 4 - this.screenHeight){
        this.curIndex = 2
        return
      }
      if(y  <= this.screenHeight * 5 && y >= this.screenHeight * 5 - this.screenHeight){
        this.curIndex = 3
        return
      }
      if(y  <= this.screenHeight * 6 && y >= this.screenHeight * 6 - this.screenHeight){
        this.curIndex = 4
        return
      }
      if(y  <= this.screenHeight * 7 && y >= this.screenHeight * 7 - this.screenHeight){
        this.curIndex = 5
        return
      }
      if(y  <= this.screenHeight * 8 && y >= this.screenHeight * 8 - this.screenHeight){
        this.curIndex = 6
        return
      }
      if(y  <= this.screenHeight * 9 && y >= this.screenHeight * 9 - this.screenHeight){
        this.curIndex = 7
        return
      }
      if(y  <= this.screenHeight * 10 && y >= this.screenHeight * 10 - this.screenHeight){
        this.curIndex = 8
        return
      }
      if(y  <= this.screenHeight * 11 && y >= this.screenHeight * 11 - this.screenHeight){
        this.curIndex = 9
        return
      }
      if(y >= this.screenHeight * 12 ){
        this.curIndex = 10
        return
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/appPub/appPubMain.vue